import { render, staticRenderFns } from "./FilterItem.mobile.component.vue?vue&type=template&id=4b85cef8&scoped=true&"
import script from "./FilterItem.mobile.component.vue?vue&type=script&lang=js&"
export * from "./FilterItem.mobile.component.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem.mobile.component.vue?vue&type=style&index=0&id=4b85cef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85cef8",
  null
  
)

export default component.exports